module.exports = __webpack_public_path__ + "img/4.304410c5.png";